import {
  SITE_WIDE_SEARCH,
  SITE_WIDE_SEARCH_SUCCESS,
  SITE_WIDE_SEARCH_FAILURE,
} from "./actionType";

// Action for Site wide Search

export const siteWideSearch = (searchId) => {
  return {
    type: SITE_WIDE_SEARCH,
    payload: searchId,
  };
};

export const siteWideSearchSuccess = (searchResults) => {
  return {
    type: SITE_WIDE_SEARCH_SUCCESS,
    payload: searchResults,
  };
};

export const siteWideSearchFailure = (error) => {
  return {
    type: SITE_WIDE_SEARCH_FAILURE,
    payload: error,
  };
};
